// TODO: decommissioning_header remove old overlay (whole file)

/*
 eslint-disable
 no-unused-vars,
 import/prefer-default-export
*/

/*
 globals
*/

const $ = window.jQuery;
const responsiveUtils = window.responsiveUtils;
const browserUtils = window.browserUtils;
const messages = {
    item: window.ACC.message.pdp.snackbar.item,
    items: window.ACC.message.pdp.snackbar.items
};
const $element = $('#AddToBag');
const $overlay = $('#Overlay');
const $image = $('.add-to-bag-snackbar__img');
const $title = $('.add-to-bag-snackbar__content__title');
const $qty = $('.add-to-bag-snackbar__content__quantity');
const $price = $('.add-to-bag-snackbar__content__price');
const overlayAnimationTime = 500;
const overlayAnimationDelay = 250;
const closeTimerTime = 5000;
const elementAnimationTime = 600;

var timer;

/**
 * Shows snackbar with number of added items on mobile device.
 * @param qty
 */
function show(popupHTML) {
    if (!responsiveUtils.isMobile()) {
        return;
    }

    var hideOverlayControls = function () {
        $overlay.hide();
        $element.hide();
        clearTimeout(timer);
    };

    hideOverlayControls();

    var hideSnackBar = function (completeCallback) {
        $overlay.fadeOut(overlayAnimationTime);
        $element.velocity({
            top: '-550px'
        }, {
            duration: elementAnimationTime,
            easing: 'easeInOutExpo',
            complete: completeCallback
        });
    };

    var closeSnackBar = function () {
        timer = setTimeout(function () {
            hideSnackBar(function () { clearTimeout(timer); });
        }, closeTimerTime);

        $('#closeBt, #Continue, #Overlay')
            .click(function (e) {
                e.preventDefault();
                clearTimeout(timer);
                hideSnackBar(function () {});
            });
    };

    $element.show();

    if (browserUtils.isIosDevice()) {
        // workaround for ios devices page load optimisation
        // prevents popup from sticking on the screen on ios devices
        // if checkout clicked and then back button pressed in ~5 sec
        $(window).on('pageshow', function (e) {
            // otherwise pagehide would be fired only once -- known WebKit bug
            window.location.reload();
        });
        $(window).on('pagehide', function (event) {
            hideOverlayControls();
        });
    }

    $overlay.delay(overlayAnimationDelay).fadeIn(overlayAnimationTime);

    $element.velocity('stop', true).velocity({
        top: '0'
    }, {
        duration: elementAnimationTime,
        easing: 'easeInOutExpo',
        complete: function () {
            closeSnackBar();
        }
    });
    const $cartContent = $('<div>').html(popupHTML);
    $image.html($cartContent.find('.prod_image').html());
    $qty.html($cartContent.find('.prod_quantity').html());
    $price.html($cartContent.find('.prod_price').html());
    $title.html($cartContent.find('.prod_info > p').html());
}

export { show };
